const readRequiredEnv = (
  key: 'VITE_SERVER_API_BASE_URL' | 'VITE_PUBLIC_SERVER_API_BASE_URL',
) => {
  const env = import.meta.env ?? {};
  const value = typeof env[key] === 'string' ? env[key].trim() : '';

  if (!value) {
    throw new Error(
      `[services] Missing required environment variable: ${key}`,
    );
  }

  return value;
};

/**
 * Returns the authenticated backend API base URL.
 */
export function serverApiBaseUrl(): string {
  return readRequiredEnv('VITE_SERVER_API_BASE_URL');
}

/**
 * Returns the public backend API base URL.
 */
export function publicServerApiBaseUrl(): string {
  return readRequiredEnv('VITE_PUBLIC_SERVER_API_BASE_URL');
}
